import React from "react";
import "./branchContact.css";

const COMPANY_NAME = "شركة حسن عاشور لقطع غيار السيارات";

const getPhones = (branch) =>
  Array.isArray(branch?.phones) ? branch.phones.filter(Boolean) : [];

export const BranchContactHeader = ({ branch }) => {
  const phones = getPhones(branch);

  return (
    <div className="invoice_info_company branch-contact-header">
      <div className="info_data branch-contact-info">
        <h2>{COMPANY_NAME}</h2>
        {branch?.address && <p>العنوان: {branch.address}</p>}
        {phones.length > 0 && (
          <div className="branch-contact-phones">
            <span>هاتف:</span>
            <div>
              {phones.map((phone) => (
                <span className="branch-contact-phone" key={phone}>
                  {phone}
                </span>
              ))}
            </div>
          </div>
        )}
      </div>
      <div className="small_logo branch-contact-logo">
        <img src="/assets/small_logo.png" alt="شعار الشركة" />
      </div>
    </div>
  );
};
